// extracted by mini-css-extract-plugin
export default {"btop":"_10b53617d0 a0d3f218e7 _88708e57fa","icon":"_4d6a1025f6 _1b7344f945","btoppink":"_81197f16c2 eca507ddb3"};